/* Generated by TinySVG. Do not edit directly. */
import { Icon3dRotate } from './icons/Icon3dRotate.tsx'
import { Icon3dView } from './icons/Icon3dView.tsx'
import { ALargeSmallIcon } from './icons/ALargeSmallIcon.tsx'
import { ActivityIcon } from './icons/ActivityIcon.tsx'
import { AlarmClockIcon } from './icons/AlarmClockIcon.tsx'
import { AlertCircleIcon } from './icons/AlertCircleIcon.tsx'
import { AlertTriangleIcon } from './icons/AlertTriangleIcon.tsx'
import { AlignCenterIcon } from './icons/AlignCenterIcon.tsx'
import { AlignLeftIcon } from './icons/AlignLeftIcon.tsx'
import { AlignRightIcon } from './icons/AlignRightIcon.tsx'
import { ApartmentIcon } from './icons/ApartmentIcon.tsx'
import { ApartmentFilledIcon } from './icons/ApartmentFilledIcon.tsx'
import { ApartmentJuicyIcon } from './icons/ApartmentJuicyIcon.tsx'
import { ArchiveIcon } from './icons/ArchiveIcon.tsx'
import { ArchiveRestoreIcon } from './icons/ArchiveRestoreIcon.tsx'
import { ArrowDownIcon } from './icons/ArrowDownIcon.tsx'
import { ArrowDownLeftIcon } from './icons/ArrowDownLeftIcon.tsx'
import { ArrowDownRightIcon } from './icons/ArrowDownRightIcon.tsx'
import { ArrowDownWideNarrowIcon } from './icons/ArrowDownWideNarrowIcon.tsx'
import { ArrowLeftIcon } from './icons/ArrowLeftIcon.tsx'
import { ArrowLeftToLineIcon } from './icons/ArrowLeftToLineIcon.tsx'
import { ArrowRightIcon } from './icons/ArrowRightIcon.tsx'
import { ArrowRightLeftIcon } from './icons/ArrowRightLeftIcon.tsx'
import { ArrowUpIcon } from './icons/ArrowUpIcon.tsx'
import { ArrowUpDownIcon } from './icons/ArrowUpDownIcon.tsx'
import { ArrowUpLeftIcon } from './icons/ArrowUpLeftIcon.tsx'
import { ArrowUpRightIcon } from './icons/ArrowUpRightIcon.tsx'
import { ArrowUpWideNarrowIcon } from './icons/ArrowUpWideNarrowIcon.tsx'
import { AtSignIcon } from './icons/AtSignIcon.tsx'
import { AwardIcon } from './icons/AwardIcon.tsx'
import { BadgeCheckIcon } from './icons/BadgeCheckIcon.tsx'
import { BarChartIcon } from './icons/BarChartIcon.tsx'
import { BarChartFilledIcon } from './icons/BarChartFilledIcon.tsx'
import { BarChartIncreasingIcon } from './icons/BarChartIncreasingIcon.tsx'
import { BellIcon } from './icons/BellIcon.tsx'
import { BikeIcon } from './icons/BikeIcon.tsx'
import { BoldIcon } from './icons/BoldIcon.tsx'
import { BookOpenIcon } from './icons/BookOpenIcon.tsx'
import { BookmarkIcon } from './icons/BookmarkIcon.tsx'
import { BotIcon } from './icons/BotIcon.tsx'
import { BotFilledIcon } from './icons/BotFilledIcon.tsx'
import { BoxIcon } from './icons/BoxIcon.tsx'
import { BoxFilledIcon } from './icons/BoxFilledIcon.tsx'
import { BoxesIcon } from './icons/BoxesIcon.tsx'
import { BracesIcon } from './icons/BracesIcon.tsx'
import { BrainIcon } from './icons/BrainIcon.tsx'
import { BrainFilledIcon } from './icons/BrainFilledIcon.tsx'
import { BriefcaseIcon } from './icons/BriefcaseIcon.tsx'
import { BugIcon } from './icons/BugIcon.tsx'
import { CalculatorIcon } from './icons/CalculatorIcon.tsx'
import { CalendarIcon } from './icons/CalendarIcon.tsx'
import { CalendarCheckIcon } from './icons/CalendarCheckIcon.tsx'
import { CalendarClockIcon } from './icons/CalendarClockIcon.tsx'
import { CameraIcon } from './icons/CameraIcon.tsx'
import { CaretDownIcon } from './icons/CaretDownIcon.tsx'
import { CaretLeftIcon } from './icons/CaretLeftIcon.tsx'
import { CaretRightIcon } from './icons/CaretRightIcon.tsx'
import { CaretUpIcon } from './icons/CaretUpIcon.tsx'
import { CheckIcon } from './icons/CheckIcon.tsx'
import { CheckCheckIcon } from './icons/CheckCheckIcon.tsx'
import { CheckCircleIcon } from './icons/CheckCircleIcon.tsx'
import { ChevronDownIcon } from './icons/ChevronDownIcon.tsx'
import { ChevronDownSmallIcon } from './icons/ChevronDownSmallIcon.tsx'
import { ChevronLeftIcon } from './icons/ChevronLeftIcon.tsx'
import { ChevronLeftSmallIcon } from './icons/ChevronLeftSmallIcon.tsx'
import { ChevronRightIcon } from './icons/ChevronRightIcon.tsx'
import { ChevronRightSmallIcon } from './icons/ChevronRightSmallIcon.tsx'
import { ChevronUpIcon } from './icons/ChevronUpIcon.tsx'
import { ChevronUpSmallIcon } from './icons/ChevronUpSmallIcon.tsx'
import { ChevronsDownIcon } from './icons/ChevronsDownIcon.tsx'
import { ChevronsDownUpIcon } from './icons/ChevronsDownUpIcon.tsx'
import { ChevronsLeftIcon } from './icons/ChevronsLeftIcon.tsx'
import { ChevronsRightIcon } from './icons/ChevronsRightIcon.tsx'
import { ChevronsUpIcon } from './icons/ChevronsUpIcon.tsx'
import { ChevronsUpDownIcon } from './icons/ChevronsUpDownIcon.tsx'
import { CircleIcon } from './icons/CircleIcon.tsx'
import { CircleArrowDownIcon } from './icons/CircleArrowDownIcon.tsx'
import { CircleChevronDownIcon } from './icons/CircleChevronDownIcon.tsx'
import { CircleCircleIcon } from './icons/CircleCircleIcon.tsx'
import { CircleCircleJuicyIcon } from './icons/CircleCircleJuicyIcon.tsx'
import { CircleDashedIcon } from './icons/CircleDashedIcon.tsx'
import { CircleDotIcon } from './icons/CircleDotIcon.tsx'
import { CirclePausedIcon } from './icons/CirclePausedIcon.tsx'
import { CirclePlusIcon } from './icons/CirclePlusIcon.tsx'
import { CircleSlashIcon } from './icons/CircleSlashIcon.tsx'
import { CircleUserIcon } from './icons/CircleUserIcon.tsx'
import { CircleUserFilledIcon } from './icons/CircleUserFilledIcon.tsx'
import { CircleUserJuicyIcon } from './icons/CircleUserJuicyIcon.tsx'
import { ClipboardIcon } from './icons/ClipboardIcon.tsx'
import { ClipboardCheckIcon } from './icons/ClipboardCheckIcon.tsx'
import { ClipboardCheckFilledIcon } from './icons/ClipboardCheckFilledIcon.tsx'
import { ClockIcon } from './icons/ClockIcon.tsx'
import { CodeIcon } from './icons/CodeIcon.tsx'
import { CodeXmlIcon } from './icons/CodeXmlIcon.tsx'
import { CoffeeIcon } from './icons/CoffeeIcon.tsx'
import { Column3Icon } from './icons/Column3Icon.tsx'
import { ColumnsIcon } from './icons/ColumnsIcon.tsx'
import { ComponentIcon } from './icons/ComponentIcon.tsx'
import { ComponentFilledIcon } from './icons/ComponentFilledIcon.tsx'
import { ContactIcon } from './icons/ContactIcon.tsx'
import { ContactFilledIcon } from './icons/ContactFilledIcon.tsx'
import { ContactJuicyIcon } from './icons/ContactJuicyIcon.tsx'
import { CopyIcon } from './icons/CopyIcon.tsx'
import { CornerDownLeftIcon } from './icons/CornerDownLeftIcon.tsx'
import { CornerDownRightIcon } from './icons/CornerDownRightIcon.tsx'
import { CornerUpLeftIcon } from './icons/CornerUpLeftIcon.tsx'
import { CornerUpRightIcon } from './icons/CornerUpRightIcon.tsx'
import { CreditCardIcon } from './icons/CreditCardIcon.tsx'
import { CreditCardJuicyIcon } from './icons/CreditCardJuicyIcon.tsx'
import { CrosshairIcon } from './icons/CrosshairIcon.tsx'
import { DatabaseIcon } from './icons/DatabaseIcon.tsx'
import { DollarSignIcon } from './icons/DollarSignIcon.tsx'
import { DonutIcon } from './icons/DonutIcon.tsx'
import { DoorClosedIcon } from './icons/DoorClosedIcon.tsx'
import { DownloadIcon } from './icons/DownloadIcon.tsx'
import { DrawerClosedLeftIcon } from './icons/DrawerClosedLeftIcon.tsx'
import { DrawerClosedRightIcon } from './icons/DrawerClosedRightIcon.tsx'
import { DrawerOpenLeftIcon } from './icons/DrawerOpenLeftIcon.tsx'
import { DrawerOpenRightIcon } from './icons/DrawerOpenRightIcon.tsx'
import { DrillIcon } from './icons/DrillIcon.tsx'
import { DropletIcon } from './icons/DropletIcon.tsx'
import { DropletFilledIcon } from './icons/DropletFilledIcon.tsx'
import { EllipsisIcon } from './icons/EllipsisIcon.tsx'
import { ExternalLinkIcon } from './icons/ExternalLinkIcon.tsx'
import { EyeIcon } from './icons/EyeIcon.tsx'
import { EyeClosedIcon } from './icons/EyeClosedIcon.tsx'
import { FileIcon } from './icons/FileIcon.tsx'
import { FileCodeIcon } from './icons/FileCodeIcon.tsx'
import { FileQuestionMarkIcon } from './icons/FileQuestionMarkIcon.tsx'
import { FileTextIcon } from './icons/FileTextIcon.tsx'
import { FilterIcon } from './icons/FilterIcon.tsx'
import { FlagIcon } from './icons/FlagIcon.tsx'
import { FlameIcon } from './icons/FlameIcon.tsx'
import { FolderIcon } from './icons/FolderIcon.tsx'
import { FolderKanbanIcon } from './icons/FolderKanbanIcon.tsx'
import { FunctionIcon } from './icons/FunctionIcon.tsx'
import { GiftIcon } from './icons/GiftIcon.tsx'
import { GitBranchIcon } from './icons/GitBranchIcon.tsx'
import { GitMergeIcon } from './icons/GitMergeIcon.tsx'
import { GlobeIcon } from './icons/GlobeIcon.tsx'
import { GlobeJuicyIcon } from './icons/GlobeJuicyIcon.tsx'
import { GridDotsIcon } from './icons/GridDotsIcon.tsx'
import { GripVerticalIcon } from './icons/GripVerticalIcon.tsx'
import { GroupIcon } from './icons/GroupIcon.tsx'
import { HammerIcon } from './icons/HammerIcon.tsx'
import { HardDriveIcon } from './icons/HardDriveIcon.tsx'
import { HardHatIcon } from './icons/HardHatIcon.tsx'
import { HashIcon } from './icons/HashIcon.tsx'
import { Heading1Icon } from './icons/Heading1Icon.tsx'
import { Heading2Icon } from './icons/Heading2Icon.tsx'
import { Heading3Icon } from './icons/Heading3Icon.tsx'
import { Heading4Icon } from './icons/Heading4Icon.tsx'
import { HeartIcon } from './icons/HeartIcon.tsx'
import { HeartHandshakeIcon } from './icons/HeartHandshakeIcon.tsx'
import { HeartPulseIcon } from './icons/HeartPulseIcon.tsx'
import { HeartPulseFilledIcon } from './icons/HeartPulseFilledIcon.tsx'
import { HelpCircleIcon } from './icons/HelpCircleIcon.tsx'
import { HistoryIcon } from './icons/HistoryIcon.tsx'
import { HomeIcon } from './icons/HomeIcon.tsx'
import { HomeFilledIcon } from './icons/HomeFilledIcon.tsx'
import { HourglassIcon } from './icons/HourglassIcon.tsx'
import { ImageIcon } from './icons/ImageIcon.tsx'
import { InboxIcon } from './icons/InboxIcon.tsx'
import { IndentDecreaseIcon } from './icons/IndentDecreaseIcon.tsx'
import { IndentIncreaseIcon } from './icons/IndentIncreaseIcon.tsx'
import { InfoIcon } from './icons/InfoIcon.tsx'
import { ItalicIcon } from './icons/ItalicIcon.tsx'
import { KeyboardIcon } from './icons/KeyboardIcon.tsx'
import { LandmarkIcon } from './icons/LandmarkIcon.tsx'
import { LayersIcon } from './icons/LayersIcon.tsx'
import { LayoutDashboardIcon } from './icons/LayoutDashboardIcon.tsx'
import { LayoutGridIcon } from './icons/LayoutGridIcon.tsx'
import { LightbulbIcon } from './icons/LightbulbIcon.tsx'
import { LinkIcon } from './icons/LinkIcon.tsx'
import { ListIcon } from './icons/ListIcon.tsx'
import { ListChecksIcon } from './icons/ListChecksIcon.tsx'
import { ListOrderedIcon } from './icons/ListOrderedIcon.tsx'
import { LiveStreamingIcon } from './icons/LiveStreamingIcon.tsx'
import { LoaderIcon } from './icons/LoaderIcon.tsx'
import { LockIcon } from './icons/LockIcon.tsx'
import { LockFilledIcon } from './icons/LockFilledIcon.tsx'
import { LogOutIcon } from './icons/LogOutIcon.tsx'
import { MailIcon } from './icons/MailIcon.tsx'
import { MailCheckIcon } from './icons/MailCheckIcon.tsx'
import { MailOpenIcon } from './icons/MailOpenIcon.tsx'
import { MapPinIcon } from './icons/MapPinIcon.tsx'
import { MapPinFilledIcon } from './icons/MapPinFilledIcon.tsx'
import { MapPinJuicyIcon } from './icons/MapPinJuicyIcon.tsx'
import { MapPinPlusIcon } from './icons/MapPinPlusIcon.tsx'
import { MaximizeIcon } from './icons/MaximizeIcon.tsx'
import { Maximize2Icon } from './icons/Maximize2Icon.tsx'
import { MedalIcon } from './icons/MedalIcon.tsx'
import { MenuIcon } from './icons/MenuIcon.tsx'
import { MessageIcon } from './icons/MessageIcon.tsx'
import { MessageDotIcon } from './icons/MessageDotIcon.tsx'
import { MessageTextIcon } from './icons/MessageTextIcon.tsx'
import { MinimizeIcon } from './icons/MinimizeIcon.tsx'
import { MinusIcon } from './icons/MinusIcon.tsx'
import { MonitorIcon } from './icons/MonitorIcon.tsx'
import { MoonIcon } from './icons/MoonIcon.tsx'
import { MoreVerticalIcon } from './icons/MoreVerticalIcon.tsx'
import { MousePointerClickIcon } from './icons/MousePointerClickIcon.tsx'
import { NavigationIcon } from './icons/NavigationIcon.tsx'
import { NetworkIcon } from './icons/NetworkIcon.tsx'
import { NotebookPenIcon } from './icons/NotebookPenIcon.tsx'
import { OrbitIcon } from './icons/OrbitIcon.tsx'
import { OrbitFilledIcon } from './icons/OrbitFilledIcon.tsx'
import { PackageIcon } from './icons/PackageIcon.tsx'
import { PackageJuicyIcon } from './icons/PackageJuicyIcon.tsx'
import { PaintRollerIcon } from './icons/PaintRollerIcon.tsx'
import { PaletteIcon } from './icons/PaletteIcon.tsx'
import { PanelRightIcon } from './icons/PanelRightIcon.tsx'
import { PanelRightCloseIcon } from './icons/PanelRightCloseIcon.tsx'
import { PaperclipIcon } from './icons/PaperclipIcon.tsx'
import { PawIcon } from './icons/PawIcon.tsx'
import { PenLineIcon } from './icons/PenLineIcon.tsx'
import { PenToolIcon } from './icons/PenToolIcon.tsx'
import { PencilIcon } from './icons/PencilIcon.tsx'
import { PercentIcon } from './icons/PercentIcon.tsx'
import { PersonIcon } from './icons/PersonIcon.tsx'
import { PhoneIcon } from './icons/PhoneIcon.tsx'
import { PhoneJuicyIcon } from './icons/PhoneJuicyIcon.tsx'
import { PickaxeIcon } from './icons/PickaxeIcon.tsx'
import { PieChartIcon } from './icons/PieChartIcon.tsx'
import { PiggyBankIcon } from './icons/PiggyBankIcon.tsx'
import { PilcrowIcon } from './icons/PilcrowIcon.tsx'
import { PinIcon } from './icons/PinIcon.tsx'
import { PipetteIcon } from './icons/PipetteIcon.tsx'
import { PlayIcon } from './icons/PlayIcon.tsx'
import { PlayCircleIcon } from './icons/PlayCircleIcon.tsx'
import { PlugIcon } from './icons/PlugIcon.tsx'
import { PlusIcon } from './icons/PlusIcon.tsx'
import { PowerIcon } from './icons/PowerIcon.tsx'
import { PowerOffIcon } from './icons/PowerOffIcon.tsx'
import { PuzzleIcon } from './icons/PuzzleIcon.tsx'
import { PyramidIcon } from './icons/PyramidIcon.tsx'
import { QuoteIcon } from './icons/QuoteIcon.tsx'
import { RadarIcon } from './icons/RadarIcon.tsx'
import { RedoIcon } from './icons/RedoIcon.tsx'
import { ReloadIcon } from './icons/ReloadIcon.tsx'
import { RepeatIcon } from './icons/RepeatIcon.tsx'
import { ReplaceIcon } from './icons/ReplaceIcon.tsx'
import { ReplyIcon } from './icons/ReplyIcon.tsx'
import { RocketIcon } from './icons/RocketIcon.tsx'
import { RotateIcon } from './icons/RotateIcon.tsx'
import { RotateCwIcon } from './icons/RotateCwIcon.tsx'
import { RulerIcon } from './icons/RulerIcon.tsx'
import { SalestrakIcon } from './icons/SalestrakIcon.tsx'
import { SaveIcon } from './icons/SaveIcon.tsx'
import { SaveCheckIcon } from './icons/SaveCheckIcon.tsx'
import { SaveOffIcon } from './icons/SaveOffIcon.tsx'
import { ScrollIcon } from './icons/ScrollIcon.tsx'
import { SearchIcon } from './icons/SearchIcon.tsx'
import { SearchXIcon } from './icons/SearchXIcon.tsx'
import { SendIcon } from './icons/SendIcon.tsx'
import { SettingsIcon } from './icons/SettingsIcon.tsx'
import { Settings2Icon } from './icons/Settings2Icon.tsx'
import { SettingsFilledIcon } from './icons/SettingsFilledIcon.tsx'
import { ShapesIcon } from './icons/ShapesIcon.tsx'
import { ShapesFilledIcon } from './icons/ShapesFilledIcon.tsx'
import { ShareIcon } from './icons/ShareIcon.tsx'
import { ShieldIcon } from './icons/ShieldIcon.tsx'
import { ShieldFilledIcon } from './icons/ShieldFilledIcon.tsx'
import { ShieldMinusIcon } from './icons/ShieldMinusIcon.tsx'
import { ShovelIcon } from './icons/ShovelIcon.tsx'
import { ShuffleIcon } from './icons/ShuffleIcon.tsx'
import { SkipBackIcon } from './icons/SkipBackIcon.tsx'
import { SkipForwardIcon } from './icons/SkipForwardIcon.tsx'
import { SlidersHorizontalIcon } from './icons/SlidersHorizontalIcon.tsx'
import { SlidersHorizontalFilledIcon } from './icons/SlidersHorizontalFilledIcon.tsx'
import { SmartphoneIcon } from './icons/SmartphoneIcon.tsx'
import { SmileIcon } from './icons/SmileIcon.tsx'
import { SmilePlusIcon } from './icons/SmilePlusIcon.tsx'
import { SparklesIcon } from './icons/SparklesIcon.tsx'
import { SpeechIcon } from './icons/SpeechIcon.tsx'
import { SplitIcon } from './icons/SplitIcon.tsx'
import { SquareIcon } from './icons/SquareIcon.tsx'
import { SquareArrowDownIcon } from './icons/SquareArrowDownIcon.tsx'
import { SquareArrowEnterRightIcon } from './icons/SquareArrowEnterRightIcon.tsx'
import { SquareArrowEnterRightJuicyIcon } from './icons/SquareArrowEnterRightJuicyIcon.tsx'
import { SquareCheckIcon } from './icons/SquareCheckIcon.tsx'
import { SquareCodeIcon } from './icons/SquareCodeIcon.tsx'
import { SquarePenIcon } from './icons/SquarePenIcon.tsx'
import { SquareUserRoundIcon } from './icons/SquareUserRoundIcon.tsx'
import { StarIcon } from './icons/StarIcon.tsx'
import { StarFilledIcon } from './icons/StarFilledIcon.tsx'
import { StrikethroughIcon } from './icons/StrikethroughIcon.tsx'
import { SunIcon } from './icons/SunIcon.tsx'
import { SunFilledIcon } from './icons/SunFilledIcon.tsx'
import { SunMoonIcon } from './icons/SunMoonIcon.tsx'
import { SwatchBookIcon } from './icons/SwatchBookIcon.tsx'
import { SwatchBookFilledIcon } from './icons/SwatchBookFilledIcon.tsx'
import { TableIcon } from './icons/TableIcon.tsx'
import { TablePropertiesIcon } from './icons/TablePropertiesIcon.tsx'
import { TabletIcon } from './icons/TabletIcon.tsx'
import { TagIcon } from './icons/TagIcon.tsx'
import { TagFilledIcon } from './icons/TagFilledIcon.tsx'
import { TagJuicyIcon } from './icons/TagJuicyIcon.tsx'
import { TargetIcon } from './icons/TargetIcon.tsx'
import { TextIcon } from './icons/TextIcon.tsx'
import { TextCursorInputIcon } from './icons/TextCursorInputIcon.tsx'
import { TextCursorInputFilledIcon } from './icons/TextCursorInputFilledIcon.tsx'
import { TextSelectIcon } from './icons/TextSelectIcon.tsx'
import { ThumbsDownIcon } from './icons/ThumbsDownIcon.tsx'
import { ThumbsUpIcon } from './icons/ThumbsUpIcon.tsx'
import { TimerIcon } from './icons/TimerIcon.tsx'
import { TrashIcon } from './icons/TrashIcon.tsx'
import { TrashFilledIcon } from './icons/TrashFilledIcon.tsx'
import { TreePineIcon } from './icons/TreePineIcon.tsx'
import { TrendingUpIcon } from './icons/TrendingUpIcon.tsx'
import { TrophyIcon } from './icons/TrophyIcon.tsx'
import { TruckIcon } from './icons/TruckIcon.tsx'
import { TypeIcon } from './icons/TypeIcon.tsx'
import { UnderlineIcon } from './icons/UnderlineIcon.tsx'
import { UndoIcon } from './icons/UndoIcon.tsx'
import { UnlinkIcon } from './icons/UnlinkIcon.tsx'
import { UnplugIcon } from './icons/UnplugIcon.tsx'
import { UploadIcon } from './icons/UploadIcon.tsx'
import { UserIcon } from './icons/UserIcon.tsx'
import { UserCheckIcon } from './icons/UserCheckIcon.tsx'
import { UserFilledIcon } from './icons/UserFilledIcon.tsx'
import { UserLockIcon } from './icons/UserLockIcon.tsx'
import { UserLockFilledIcon } from './icons/UserLockFilledIcon.tsx'
import { UserNotebookIcon } from './icons/UserNotebookIcon.tsx'
import { UserNotebookFilledIcon } from './icons/UserNotebookFilledIcon.tsx'
import { UserNotebookJuicyIcon } from './icons/UserNotebookJuicyIcon.tsx'
import { UserPlusIcon } from './icons/UserPlusIcon.tsx'
import { UsersIcon } from './icons/UsersIcon.tsx'
import { UsersFilledIcon } from './icons/UsersFilledIcon.tsx'
import { UsersJuicyIcon } from './icons/UsersJuicyIcon.tsx'
import { ViewBoardIcon } from './icons/ViewBoardIcon.tsx'
import { ViewDashboardIcon } from './icons/ViewDashboardIcon.tsx'
import { ViewListIcon } from './icons/ViewListIcon.tsx'
import { VoicemailIcon } from './icons/VoicemailIcon.tsx'
import { VolumeIcon } from './icons/VolumeIcon.tsx'
import { WandSparklesIcon } from './icons/WandSparklesIcon.tsx'
import { WebhookIcon } from './icons/WebhookIcon.tsx'
import { WifiIcon } from './icons/WifiIcon.tsx'
import { WifiOffIcon } from './icons/WifiOffIcon.tsx'
import { WorkflowIcon } from './icons/WorkflowIcon.tsx'
import { WorkflowFilledIcon } from './icons/WorkflowFilledIcon.tsx'
import { WorkflowJuicyIcon } from './icons/WorkflowJuicyIcon.tsx'
import { WrenchIcon } from './icons/WrenchIcon.tsx'
import { XIcon } from './icons/XIcon.tsx'
import { XCircleIcon } from './icons/XCircleIcon.tsx'
import { ZapIcon } from './icons/ZapIcon.tsx'
import { ZapFilledIcon } from './icons/ZapFilledIcon.tsx'
import { ZapOffIcon } from './icons/ZapOffIcon.tsx'
import { ZoomInIcon } from './icons/ZoomInIcon.tsx'
import { ZoomOutIcon } from './icons/ZoomOutIcon.tsx'

export { Icon3dRotate, Icon3dView, ALargeSmallIcon, ActivityIcon, AlarmClockIcon, AlertCircleIcon, AlertTriangleIcon, AlignCenterIcon, AlignLeftIcon, AlignRightIcon, ApartmentIcon, ApartmentFilledIcon, ApartmentJuicyIcon, ArchiveIcon, ArchiveRestoreIcon, ArrowDownIcon, ArrowDownLeftIcon, ArrowDownRightIcon, ArrowDownWideNarrowIcon, ArrowLeftIcon, ArrowLeftToLineIcon, ArrowRightIcon, ArrowRightLeftIcon, ArrowUpIcon, ArrowUpDownIcon, ArrowUpLeftIcon, ArrowUpRightIcon, ArrowUpWideNarrowIcon, AtSignIcon, AwardIcon, BadgeCheckIcon, BarChartIcon, BarChartFilledIcon, BarChartIncreasingIcon, BellIcon, BikeIcon, BoldIcon, BookOpenIcon, BookmarkIcon, BotIcon, BotFilledIcon, BoxIcon, BoxFilledIcon, BoxesIcon, BracesIcon, BrainIcon, BrainFilledIcon, BriefcaseIcon, BugIcon, CalculatorIcon, CalendarIcon, CalendarCheckIcon, CalendarClockIcon, CameraIcon, CaretDownIcon, CaretLeftIcon, CaretRightIcon, CaretUpIcon, CheckIcon, CheckCheckIcon, CheckCircleIcon, ChevronDownIcon, ChevronDownSmallIcon, ChevronLeftIcon, ChevronLeftSmallIcon, ChevronRightIcon, ChevronRightSmallIcon, ChevronUpIcon, ChevronUpSmallIcon, ChevronsDownIcon, ChevronsDownUpIcon, ChevronsLeftIcon, ChevronsRightIcon, ChevronsUpIcon, ChevronsUpDownIcon, CircleIcon, CircleArrowDownIcon, CircleChevronDownIcon, CircleCircleIcon, CircleCircleJuicyIcon, CircleDashedIcon, CircleDotIcon, CirclePausedIcon, CirclePlusIcon, CircleSlashIcon, CircleUserIcon, CircleUserFilledIcon, CircleUserJuicyIcon, ClipboardIcon, ClipboardCheckIcon, ClipboardCheckFilledIcon, ClockIcon, CodeIcon, CodeXmlIcon, CoffeeIcon, Column3Icon, ColumnsIcon, ComponentIcon, ComponentFilledIcon, ContactIcon, ContactFilledIcon, ContactJuicyIcon, CopyIcon, CornerDownLeftIcon, CornerDownRightIcon, CornerUpLeftIcon, CornerUpRightIcon, CreditCardIcon, CreditCardJuicyIcon, CrosshairIcon, DatabaseIcon, DollarSignIcon, DonutIcon, DoorClosedIcon, DownloadIcon, DrawerClosedLeftIcon, DrawerClosedRightIcon, DrawerOpenLeftIcon, DrawerOpenRightIcon, DrillIcon, DropletIcon, DropletFilledIcon, EllipsisIcon, ExternalLinkIcon, EyeIcon, EyeClosedIcon, FileIcon, FileCodeIcon, FileQuestionMarkIcon, FileTextIcon, FilterIcon, FlagIcon, FlameIcon, FolderIcon, FolderKanbanIcon, FunctionIcon, GiftIcon, GitBranchIcon, GitMergeIcon, GlobeIcon, GlobeJuicyIcon, GridDotsIcon, GripVerticalIcon, GroupIcon, HammerIcon, HardDriveIcon, HardHatIcon, HashIcon, Heading1Icon, Heading2Icon, Heading3Icon, Heading4Icon, HeartIcon, HeartHandshakeIcon, HeartPulseIcon, HeartPulseFilledIcon, HelpCircleIcon, HistoryIcon, HomeIcon, HomeFilledIcon, HourglassIcon, ImageIcon, InboxIcon, IndentDecreaseIcon, IndentIncreaseIcon, InfoIcon, ItalicIcon, KeyboardIcon, LandmarkIcon, LayersIcon, LayoutDashboardIcon, LayoutGridIcon, LightbulbIcon, LinkIcon, ListIcon, ListChecksIcon, ListOrderedIcon, LiveStreamingIcon, LoaderIcon, LockIcon, LockFilledIcon, LogOutIcon, MailIcon, MailCheckIcon, MailOpenIcon, MapPinIcon, MapPinFilledIcon, MapPinJuicyIcon, MapPinPlusIcon, MaximizeIcon, Maximize2Icon, MedalIcon, MenuIcon, MessageIcon, MessageDotIcon, MessageTextIcon, MinimizeIcon, MinusIcon, MonitorIcon, MoonIcon, MoreVerticalIcon, MousePointerClickIcon, NavigationIcon, NetworkIcon, NotebookPenIcon, OrbitIcon, OrbitFilledIcon, PackageIcon, PackageJuicyIcon, PaintRollerIcon, PaletteIcon, PanelRightIcon, PanelRightCloseIcon, PaperclipIcon, PawIcon, PenLineIcon, PenToolIcon, PencilIcon, PercentIcon, PersonIcon, PhoneIcon, PhoneJuicyIcon, PickaxeIcon, PieChartIcon, PiggyBankIcon, PilcrowIcon, PinIcon, PipetteIcon, PlayIcon, PlayCircleIcon, PlugIcon, PlusIcon, PowerIcon, PowerOffIcon, PuzzleIcon, PyramidIcon, QuoteIcon, RadarIcon, RedoIcon, ReloadIcon, RepeatIcon, ReplaceIcon, ReplyIcon, RocketIcon, RotateIcon, RotateCwIcon, RulerIcon, SalestrakIcon, SaveIcon, SaveCheckIcon, SaveOffIcon, ScrollIcon, SearchIcon, SearchXIcon, SendIcon, SettingsIcon, Settings2Icon, SettingsFilledIcon, ShapesIcon, ShapesFilledIcon, ShareIcon, ShieldIcon, ShieldFilledIcon, ShieldMinusIcon, ShovelIcon, ShuffleIcon, SkipBackIcon, SkipForwardIcon, SlidersHorizontalIcon, SlidersHorizontalFilledIcon, SmartphoneIcon, SmileIcon, SmilePlusIcon, SparklesIcon, SpeechIcon, SplitIcon, SquareIcon, SquareArrowDownIcon, SquareArrowEnterRightIcon, SquareArrowEnterRightJuicyIcon, SquareCheckIcon, SquareCodeIcon, SquarePenIcon, SquareUserRoundIcon, StarIcon, StarFilledIcon, StrikethroughIcon, SunIcon, SunFilledIcon, SunMoonIcon, SwatchBookIcon, SwatchBookFilledIcon, TableIcon, TablePropertiesIcon, TabletIcon, TagIcon, TagFilledIcon, TagJuicyIcon, TargetIcon, TextIcon, TextCursorInputIcon, TextCursorInputFilledIcon, TextSelectIcon, ThumbsDownIcon, ThumbsUpIcon, TimerIcon, TrashIcon, TrashFilledIcon, TreePineIcon, TrendingUpIcon, TrophyIcon, TruckIcon, TypeIcon, UnderlineIcon, UndoIcon, UnlinkIcon, UnplugIcon, UploadIcon, UserIcon, UserCheckIcon, UserFilledIcon, UserLockIcon, UserLockFilledIcon, UserNotebookIcon, UserNotebookFilledIcon, UserNotebookJuicyIcon, UserPlusIcon, UsersIcon, UsersFilledIcon, UsersJuicyIcon, ViewBoardIcon, ViewDashboardIcon, ViewListIcon, VoicemailIcon, VolumeIcon, WandSparklesIcon, WebhookIcon, WifiIcon, WifiOffIcon, WorkflowIcon, WorkflowFilledIcon, WorkflowJuicyIcon, WrenchIcon, XIcon, XCircleIcon, ZapIcon, ZapFilledIcon, ZapOffIcon, ZoomInIcon, ZoomOutIcon }
export type { TinyIconProps } from './types.ts'

export const icons = {
  "3d-rotate": Icon3dRotate,
  "3d-view": Icon3dView,
  "a-large-small": ALargeSmallIcon,
  "activity": ActivityIcon,
  "alarm-clock": AlarmClockIcon,
  "alert-circle": AlertCircleIcon,
  "alert-triangle": AlertTriangleIcon,
  "align-center": AlignCenterIcon,
  "align-left": AlignLeftIcon,
  "align-right": AlignRightIcon,
  "apartment": ApartmentIcon,
  "apartment-filled": ApartmentFilledIcon,
  "apartment-juicy": ApartmentJuicyIcon,
  "archive": ArchiveIcon,
  "archive-restore": ArchiveRestoreIcon,
  "arrow-down": ArrowDownIcon,
  "arrow-down-left": ArrowDownLeftIcon,
  "arrow-down-right": ArrowDownRightIcon,
  "arrow-down-wide-narrow": ArrowDownWideNarrowIcon,
  "arrow-left": ArrowLeftIcon,
  "arrow-left-to-line": ArrowLeftToLineIcon,
  "arrow-right": ArrowRightIcon,
  "arrow-right-left": ArrowRightLeftIcon,
  "arrow-up": ArrowUpIcon,
  "arrow-up-down": ArrowUpDownIcon,
  "arrow-up-left": ArrowUpLeftIcon,
  "arrow-up-right": ArrowUpRightIcon,
  "arrow-up-wide-narrow": ArrowUpWideNarrowIcon,
  "at-sign": AtSignIcon,
  "award": AwardIcon,
  "badge-check": BadgeCheckIcon,
  "bar-chart": BarChartIcon,
  "bar-chart-filled": BarChartFilledIcon,
  "bar-chart-increasing": BarChartIncreasingIcon,
  "bell": BellIcon,
  "bike": BikeIcon,
  "bold": BoldIcon,
  "book-open": BookOpenIcon,
  "bookmark": BookmarkIcon,
  "bot": BotIcon,
  "bot-filled": BotFilledIcon,
  "box": BoxIcon,
  "box-filled": BoxFilledIcon,
  "boxes": BoxesIcon,
  "braces": BracesIcon,
  "brain": BrainIcon,
  "brain-filled": BrainFilledIcon,
  "briefcase": BriefcaseIcon,
  "bug": BugIcon,
  "calculator": CalculatorIcon,
  "calendar": CalendarIcon,
  "calendar-check": CalendarCheckIcon,
  "calendar-clock": CalendarClockIcon,
  "camera": CameraIcon,
  "caret-down": CaretDownIcon,
  "caret-left": CaretLeftIcon,
  "caret-right": CaretRightIcon,
  "caret-up": CaretUpIcon,
  "check": CheckIcon,
  "check-check": CheckCheckIcon,
  "check-circle": CheckCircleIcon,
  "chevron-down": ChevronDownIcon,
  "chevron-down-small": ChevronDownSmallIcon,
  "chevron-left": ChevronLeftIcon,
  "chevron-left-small": ChevronLeftSmallIcon,
  "chevron-right": ChevronRightIcon,
  "chevron-right-small": ChevronRightSmallIcon,
  "chevron-up": ChevronUpIcon,
  "chevron-up-small": ChevronUpSmallIcon,
  "chevrons-down": ChevronsDownIcon,
  "chevrons-down-up": ChevronsDownUpIcon,
  "chevrons-left": ChevronsLeftIcon,
  "chevrons-right": ChevronsRightIcon,
  "chevrons-up": ChevronsUpIcon,
  "chevrons-up-down": ChevronsUpDownIcon,
  "circle": CircleIcon,
  "circle-arrow-down": CircleArrowDownIcon,
  "circle-chevron-down": CircleChevronDownIcon,
  "circle-circle": CircleCircleIcon,
  "circle-circle-juicy": CircleCircleJuicyIcon,
  "circle-dashed": CircleDashedIcon,
  "circle-dot": CircleDotIcon,
  "circle-paused": CirclePausedIcon,
  "circle-plus": CirclePlusIcon,
  "circle-slash": CircleSlashIcon,
  "circle-user": CircleUserIcon,
  "circle-user-filled": CircleUserFilledIcon,
  "circle-user-juicy": CircleUserJuicyIcon,
  "clipboard": ClipboardIcon,
  "clipboard-check": ClipboardCheckIcon,
  "clipboard-check-filled": ClipboardCheckFilledIcon,
  "clock": ClockIcon,
  "code": CodeIcon,
  "code-xml": CodeXmlIcon,
  "coffee": CoffeeIcon,
  "column-3": Column3Icon,
  "columns": ColumnsIcon,
  "component": ComponentIcon,
  "component-filled": ComponentFilledIcon,
  "contact": ContactIcon,
  "contact-filled": ContactFilledIcon,
  "contact-juicy": ContactJuicyIcon,
  "copy": CopyIcon,
  "corner-down-left": CornerDownLeftIcon,
  "corner-down-right": CornerDownRightIcon,
  "corner-up-left": CornerUpLeftIcon,
  "corner-up-right": CornerUpRightIcon,
  "credit-card": CreditCardIcon,
  "credit-card-juicy": CreditCardJuicyIcon,
  "crosshair": CrosshairIcon,
  "database": DatabaseIcon,
  "dollar-sign": DollarSignIcon,
  "donut": DonutIcon,
  "door-closed": DoorClosedIcon,
  "download": DownloadIcon,
  "drawer-closed-left": DrawerClosedLeftIcon,
  "drawer-closed-right": DrawerClosedRightIcon,
  "drawer-open-left": DrawerOpenLeftIcon,
  "drawer-open-right": DrawerOpenRightIcon,
  "drill": DrillIcon,
  "droplet": DropletIcon,
  "droplet-filled": DropletFilledIcon,
  "ellipsis": EllipsisIcon,
  "external-link": ExternalLinkIcon,
  "eye": EyeIcon,
  "eye-closed": EyeClosedIcon,
  "file": FileIcon,
  "file-code": FileCodeIcon,
  "file-question-mark": FileQuestionMarkIcon,
  "file-text": FileTextIcon,
  "filter": FilterIcon,
  "flag": FlagIcon,
  "flame": FlameIcon,
  "folder": FolderIcon,
  "folder-kanban": FolderKanbanIcon,
  "function": FunctionIcon,
  "gift": GiftIcon,
  "git-branch": GitBranchIcon,
  "git-merge": GitMergeIcon,
  "globe": GlobeIcon,
  "globe-juicy": GlobeJuicyIcon,
  "grid-dots": GridDotsIcon,
  "grip-vertical": GripVerticalIcon,
  "group": GroupIcon,
  "hammer": HammerIcon,
  "hard-drive": HardDriveIcon,
  "hard-hat": HardHatIcon,
  "hash": HashIcon,
  "heading-1": Heading1Icon,
  "heading-2": Heading2Icon,
  "heading-3": Heading3Icon,
  "heading-4": Heading4Icon,
  "heart": HeartIcon,
  "heart-handshake": HeartHandshakeIcon,
  "heart-pulse": HeartPulseIcon,
  "heart-pulse-filled": HeartPulseFilledIcon,
  "help-circle": HelpCircleIcon,
  "history": HistoryIcon,
  "home": HomeIcon,
  "home-filled": HomeFilledIcon,
  "hourglass": HourglassIcon,
  "image": ImageIcon,
  "inbox": InboxIcon,
  "indent-decrease": IndentDecreaseIcon,
  "indent-increase": IndentIncreaseIcon,
  "info": InfoIcon,
  "italic": ItalicIcon,
  "keyboard": KeyboardIcon,
  "landmark": LandmarkIcon,
  "layers": LayersIcon,
  "layout-dashboard": LayoutDashboardIcon,
  "layout-grid": LayoutGridIcon,
  "lightbulb": LightbulbIcon,
  "link": LinkIcon,
  "list": ListIcon,
  "list-checks": ListChecksIcon,
  "list-ordered": ListOrderedIcon,
  "live-streaming": LiveStreamingIcon,
  "loader": LoaderIcon,
  "lock": LockIcon,
  "lock-filled": LockFilledIcon,
  "log-out": LogOutIcon,
  "mail": MailIcon,
  "mail-check": MailCheckIcon,
  "mail-open": MailOpenIcon,
  "map-pin": MapPinIcon,
  "map-pin-filled": MapPinFilledIcon,
  "map-pin-juicy": MapPinJuicyIcon,
  "map-pin-plus": MapPinPlusIcon,
  "maximize": MaximizeIcon,
  "maximize-2": Maximize2Icon,
  "medal": MedalIcon,
  "menu": MenuIcon,
  "message": MessageIcon,
  "message-dot": MessageDotIcon,
  "message-text": MessageTextIcon,
  "minimize": MinimizeIcon,
  "minus": MinusIcon,
  "monitor": MonitorIcon,
  "moon": MoonIcon,
  "more-vertical": MoreVerticalIcon,
  "mouse-pointer-click": MousePointerClickIcon,
  "navigation": NavigationIcon,
  "network": NetworkIcon,
  "notebook-pen": NotebookPenIcon,
  "orbit": OrbitIcon,
  "orbit-filled": OrbitFilledIcon,
  "package": PackageIcon,
  "package-juicy": PackageJuicyIcon,
  "paint-roller": PaintRollerIcon,
  "palette": PaletteIcon,
  "panel-right": PanelRightIcon,
  "panel-right-close": PanelRightCloseIcon,
  "paperclip": PaperclipIcon,
  "paw": PawIcon,
  "pen-line": PenLineIcon,
  "pen-tool": PenToolIcon,
  "pencil": PencilIcon,
  "percent": PercentIcon,
  "person": PersonIcon,
  "phone": PhoneIcon,
  "phone-juicy": PhoneJuicyIcon,
  "pickaxe": PickaxeIcon,
  "pie-chart": PieChartIcon,
  "piggy-bank": PiggyBankIcon,
  "pilcrow": PilcrowIcon,
  "pin": PinIcon,
  "pipette": PipetteIcon,
  "play": PlayIcon,
  "play-circle": PlayCircleIcon,
  "plug": PlugIcon,
  "plus": PlusIcon,
  "power": PowerIcon,
  "power-off": PowerOffIcon,
  "puzzle": PuzzleIcon,
  "pyramid": PyramidIcon,
  "quote": QuoteIcon,
  "radar": RadarIcon,
  "redo": RedoIcon,
  "reload": ReloadIcon,
  "repeat": RepeatIcon,
  "replace": ReplaceIcon,
  "reply": ReplyIcon,
  "rocket": RocketIcon,
  "rotate": RotateIcon,
  "rotate-cw": RotateCwIcon,
  "ruler": RulerIcon,
  "salestrak": SalestrakIcon,
  "save": SaveIcon,
  "save-check": SaveCheckIcon,
  "save-off": SaveOffIcon,
  "scroll": ScrollIcon,
  "search": SearchIcon,
  "search-x": SearchXIcon,
  "send": SendIcon,
  "settings": SettingsIcon,
  "settings-2": Settings2Icon,
  "settings-filled": SettingsFilledIcon,
  "shapes": ShapesIcon,
  "shapes-filled": ShapesFilledIcon,
  "share": ShareIcon,
  "shield": ShieldIcon,
  "shield-filled": ShieldFilledIcon,
  "shield-minus": ShieldMinusIcon,
  "shovel": ShovelIcon,
  "shuffle": ShuffleIcon,
  "skip-back": SkipBackIcon,
  "skip-forward": SkipForwardIcon,
  "sliders-horizontal": SlidersHorizontalIcon,
  "sliders-horizontal-filled": SlidersHorizontalFilledIcon,
  "smartphone": SmartphoneIcon,
  "smile": SmileIcon,
  "smile-plus": SmilePlusIcon,
  "sparkles": SparklesIcon,
  "speech": SpeechIcon,
  "split": SplitIcon,
  "square": SquareIcon,
  "square-arrow-down": SquareArrowDownIcon,
  "square-arrow-enter-right": SquareArrowEnterRightIcon,
  "square-arrow-enter-right-juicy": SquareArrowEnterRightJuicyIcon,
  "square-check": SquareCheckIcon,
  "square-code": SquareCodeIcon,
  "square-pen": SquarePenIcon,
  "square-user-round": SquareUserRoundIcon,
  "star": StarIcon,
  "star-filled": StarFilledIcon,
  "strikethrough": StrikethroughIcon,
  "sun": SunIcon,
  "sun-filled": SunFilledIcon,
  "sun-moon": SunMoonIcon,
  "swatch-book": SwatchBookIcon,
  "swatch-book-filled": SwatchBookFilledIcon,
  "table": TableIcon,
  "table-properties": TablePropertiesIcon,
  "tablet": TabletIcon,
  "tag": TagIcon,
  "tag-filled": TagFilledIcon,
  "tag-juicy": TagJuicyIcon,
  "target": TargetIcon,
  "text": TextIcon,
  "text-cursor-input": TextCursorInputIcon,
  "text-cursor-input-filled": TextCursorInputFilledIcon,
  "text-select": TextSelectIcon,
  "thumbs-down": ThumbsDownIcon,
  "thumbs-up": ThumbsUpIcon,
  "timer": TimerIcon,
  "trash": TrashIcon,
  "trash-filled": TrashFilledIcon,
  "tree-pine": TreePineIcon,
  "trending-up": TrendingUpIcon,
  "trophy": TrophyIcon,
  "truck": TruckIcon,
  "type": TypeIcon,
  "underline": UnderlineIcon,
  "undo": UndoIcon,
  "unlink": UnlinkIcon,
  "unplug": UnplugIcon,
  "upload": UploadIcon,
  "user": UserIcon,
  "user-check": UserCheckIcon,
  "user-filled": UserFilledIcon,
  "user-lock": UserLockIcon,
  "user-lock-filled": UserLockFilledIcon,
  "user-notebook": UserNotebookIcon,
  "user-notebook-filled": UserNotebookFilledIcon,
  "user-notebook-juicy": UserNotebookJuicyIcon,
  "user-plus": UserPlusIcon,
  "users": UsersIcon,
  "users-filled": UsersFilledIcon,
  "users-juicy": UsersJuicyIcon,
  "view-board": ViewBoardIcon,
  "view-dashboard": ViewDashboardIcon,
  "view-list": ViewListIcon,
  "voicemail": VoicemailIcon,
  "volume": VolumeIcon,
  "wand-sparkles": WandSparklesIcon,
  "webhook": WebhookIcon,
  "wifi": WifiIcon,
  "wifi-off": WifiOffIcon,
  "workflow": WorkflowIcon,
  "workflow-filled": WorkflowFilledIcon,
  "workflow-juicy": WorkflowJuicyIcon,
  "wrench": WrenchIcon,
  "x": XIcon,
  "x-circle": XCircleIcon,
  "zap": ZapIcon,
  "zap-filled": ZapFilledIcon,
  "zap-off": ZapOffIcon,
  "zoom-in": ZoomInIcon,
  "zoom-out": ZoomOutIcon,
} as const

export type IconName = keyof typeof icons
export { iconNames } from './names.ts'

export { TINY_SVG_SOURCE_HASH } from './source-hash.ts'
